import type {
  CompetitorNearbyPlaceDto,
  CompetitorSampledReviewDto,
} from '@up2stay/up2promo-api-client';
import { Button } from '@up2stay/up2promo-ui';
import { X } from 'lucide-react';

import { CompetitorSampleReviews } from '@/core/components/reputation/competitor-sample-reviews';
import { PlaceActions } from '@/core/components/reputation/competitor-theater-place-actions';
import { PlaceStats } from '@/core/components/reputation/competitor-theater-place-stats';
import type { CompetitorTheaterLabels } from '@/core/components/reputation/competitor-theater-shared';

export function PlaceDetailBody({
  place,
  labels,
  yourAverageRating,
  atLimit,
  isAdding,
  isRemoving,
  onTrack,
  onRemove,
  onClose,
  sampleReviews = [],
}: {
  place: CompetitorNearbyPlaceDto;
  labels: CompetitorTheaterLabels;
  yourAverageRating?: number;
  atLimit: boolean;
  isAdding: boolean;
  isRemoving: boolean;
  onTrack: () => void;
  onRemove: () => void;
  onClose: () => void;
  /** Google sample reviews of a tracked competitor. */
  sampleReviews?: readonly CompetitorSampledReviewDto[];
}) {
  return (
    <>
      <div className="mb-1 flex items-start justify-between gap-2">
        <h3 className="text-balance text-lg font-semibold tracking-tight">
          {place.name}
        </h3>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-8 shrink-0"
          onClick={onClose}
          aria-label={labels.close}
        >
          <X className="size-4" />
        </Button>
      </div>
      {place.address ? (
        <p className="text-muted-foreground mb-4 text-sm text-pretty">
          {place.address}
        </p>
      ) : (
        <div className="mb-4" />
      )}
      <PlaceStats
        place={place}
        labels={labels}
        yourAverageRating={yourAverageRating}
      />
      <div className="mt-5">
        <CompetitorSampleReviews
          reviews={sampleReviews}
          title={labels.sampleReviews}
        />
      </div>
      <div className="mt-auto flex flex-col gap-2 pt-6">
        <PlaceActions
          place={place}
          labels={labels}
          atLimit={atLimit}
          isAdding={isAdding}
          isRemoving={isRemoving}
          onTrack={onTrack}
          onRemove={onRemove}
        />
      </div>
    </>
  );
}
